export const urls = {
    demoRequestUrl: 'https://outlook.office365.com/owa/calendar/FBOLinxSales@fuelerlinx.com/bookings/',
    outsideGatePath: '/outside-the-gate-layout/auth?token=',
}
